var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDefaultProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 108,
    viewBox: "0 0 108 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M54 99.045C78.8528 99.045 99 78.8979 99 54.045C99 29.1922 78.8528 9.04504 54 9.04504C29.1472 9.04504 9 29.1922 9 54.045C9 78.8979 29.1472 99.045 54 99.045Z",
    fill: "#999999"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54 31.23C44.685 31.23 37.125 38.79 37.125 48.105C37.125 57.24 44.28 64.665 53.775 64.935C53.91 64.935 54.09 64.935 54.18 64.935C54.27 64.935 54.405 64.935 54.495 64.935C54.54 64.935 54.585 64.935 54.585 64.935C63.675 64.62 70.83 57.24 70.875 48.105C70.875 38.79 63.315 31.23 54 31.23Z",
    fill: "#424549"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M84.5102 87.12C76.5002 94.5 65.7902 99.045 54.0002 99.045C42.2102 99.045 31.5002 94.5 23.4902 87.12C24.5702 83.025 27.4952 79.29 31.7702 76.41C44.0552 68.22 64.0352 68.22 76.2302 76.41C80.5502 79.29 83.4302 83.025 84.5102 87.12Z",
    fill: "#424549"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultProfile);
export default __webpack_public_path__ + "static/media/defaultProfile.93f20d408f68f03018f7284527785a49.svg";
export { ForwardRef as ReactComponent };